var map = {
	"./pistol_default_active.svg": 7121,
	"./pistol_law_prestige_active.svg": 3874,
	"./rifle_default_active.svg": 2054,
	"./rifle_mafia_rouge_active.svg": 40,
	"./shotgun_default_active.svg": 8404,
	"./sniper_default_active.svg": 6240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1930;